import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/book',
    name: 'book',
    component: () => import('../views/book.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
